import { enumPropsFactoryProvider, objectToEnumMap } from './enum-helper';

/**
 * Расположение
 * @type {Object}
 */
export var POSITION = {
    left: 'left',
    right: 'right',
    center: 'center',
    auto: 'auto'
};

var AVAILABLE_POSITION = objectToEnumMap(POSITION);

/**
 * Парсера параметра position
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-position.json
 * @param  {String} position
 * @param  {String} defaultPosition
 * @return {String}
 */
export default enumPropsFactoryProvider(AVAILABLE_POSITION, POSITION.auto);